module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-43.b301c12f.png";